import { createSvgComponent } from "../../icon/createSvgComponent";
import Referral from "@core/icon/assets/referral.svg";
export default createSvgComponent(Referral);